function getDate(timer, is) {
  // 获取现行时间
  var myDate;
  if (timer) {
    myDate = new Date(timer);
  } else {
    myDate = new Date();
  }
  var year = myDate.getFullYear();
  var month =
    myDate.getMonth() + 1 < 10
      ? "0" + (myDate.getMonth() + 1)
      : myDate.getMonth() + 1;
  var date =
    myDate.getDate() < 10 ? "0" + myDate.getDate() : myDate.getDate();
  var h =
    myDate.getHours() < 10 ? "0" + myDate.getHours() : myDate.getHours();
  var m =
    myDate.getMinutes() < 10
      ? "0" + myDate.getMinutes()
      : myDate.getMinutes();
  var s =
    myDate.getSeconds() < 10
      ? "0" + myDate.getSeconds()
      : myDate.getSeconds();
  return is ? year + '-' + month + '-' + date + ' ' + h + ':' + m : {
    n: year,
    y: month,
    r: date,
    h: h,
    f: m,

  };
}

export default getDate


// WEBPACK FOOTER //
// ./src/untils/getDate.js